// Real data for Dr. Adrián Cuéllar Barboza

export const doctorInfo = {
  name: "Dr. Adrián Cuéllar Barboza",
  credentials: "Médico Cirujano, Especialista en Dermatología",
  experience: "+5 años de experiencia",
  specialties: ["Dermatología Médica", "Cirugía Dermatológica", "Cirugía Micrográfica de Mohs", "Oncología Cutánea", "Dermatología Estética"],
  image: "https://customer-assets.emergentagent.com/job_skincare-clinic/artifacts/198s12ih_IMG_7298%20copy.JPG",
  bio: "Dr. Adrián Cuéllar Barboza es un dermatólogo especializado con más de 5 años de experiencia en el tratamiento de condiciones dermatológicas. Certificado por el Consejo Mexicano de Dermatología y miembro del Sistema Nacional de Investigadores Nivel I, se especializa en cirugía dermatológica y oncología cutánea.",
  education: [
    "Médico Cirujano y Partero - UANL (2008-2014)",
    "Especialidad en Dermatología - Hospital Universitario Dr. José E. González, UANL (2016-2020)",
    "Rotación Clínica e Investigación - Wake Forest Baptist Health, North Carolina (2019)",
    "Máster en Dermatología Clínica - CEU Universidad Cardenal Herrera (2020)",
    "Alta Especialidad en Cirugía Dermatológica - Hospital Universitario Dr. José E. González, UANL (2020-2021)",
    "Cirugía Micrográfica de Mohs - Instituto Alexander Fleming, Buenos Aires (2022)",
    "Diplomatura en Oncología Cutánea y Cirugía de Mohs - Pontificia Universidad Católica Argentina Santa María de los Buenos Aires (2024)"
  ],
  certifications: [
    "Certificado por el Consejo Mexicano de Dermatología 2025",
    "Miembro del Sistema Nacional de Investigadores Nivel I",
    "Profesor Titular de Dermatología en el Servicio de Dermatología del Hospital Universitario \"Dr. José E. González\"",
    "Miembro activo de la Sociedad Mexicana de Cirugía Dermatológica y Oncológica"
  ]
};

export const services = [
  {
    id: 1,
    title: "Dermatología Médica",
    description: "Diagnóstico y tratamiento integral de enfermedades de la piel, cabello y uñas",
    icon: "Stethoscope",
    treatments: [
      "Melasma (Paño)",
      "Manchas de sol",
      "Acné",
      "Rosácea",
      "Vitiligo",
      "Psoriasis",
      "Dermatitis atópica y de contacto",
      "Ronchas y alergias",
      "Picaduras",
      "Infecciones",
      "Herpes zoster",
      "Caída de cabello",
      "Caspa/ Dermatitis seborréica",
      "Piel seca",
      "Hongos",
      "Parásitos",
      "Verrugas",
      "Cuidado general de la piel",
      "Prevención de cáncer de piel",
      "Lunares",
      "Hiperhidrosis (Sudoración excesiva)"
    ]
  },
  {
    id: 2,
    title: "Medicina Estética",
    description: "Tratamientos avanzados para rejuvenecimiento y embellecimiento facial y corporal",
    icon: "Sparkles",
    treatments: [
      "Limpieza facial con microdermoabrasión",
      "Hydrafacial Elite",
      "Toxina botulínica (Botox)",
      "Rellenos de ácido hialurónico",
      "Bioestimulantes (Sculptra, Profhilo)",
      "Microneedling (Dermapen)",
      "Peelings químicos",
      "Luz pulsada intensa",
      "Laser de CO2",
      "Laser Diodo (SOPRANO) depilación",
      "Laser para tatuajes",
      "Laser para manchas de sol",
      "Laser para enrojecimiento",
      "Laser para várices en las piernas",
      "Ultrasonido microfocalizado (Liftera)"
    ]
  },
  {
    id: 3,
    title: "Cirugía Dermatológica",
    description: "Procedimientos quirúrgicos especializados con técnicas de vanguardia",
    icon: "Shield",
    treatments: [
      "Cirugía de cáncer de piel (Mohs)",
      "Cirugía para lunares",
      "Extirpación de lipomas",
      "Remoción de quistes",
      "Eliminación de tatuajes",
      "Corrección de cicatrices",
      "Cirugía reconstructiva",
      "Biopsias especializadas"
    ]
  }
];

export const detailedServices = {
  enfermedadesTratadas: [
    "Melasma (Paño)",
    "Manchas de sol (Léntigos)",
    "Verrugas de la edad",
    "Arrugas",
    "Piel seca",
    "Caída de cabello",
    "Acné",
    "Rosácea",
    "Vitiligo",
    "Lunares",
    "Psoriasis",
    "Ronchas y alergias",
    "Picaduras e infecciones",
    "Quemaduras",
    "Caspa",
    "Dermatitis atópica",
    "Dermatitis del pañal",
    "Alergia de contacto",
    "Piojos",
    "Parásitos",
    "Hongos",
    "Hiperhidrosis"
  ],
  medicinaEstetica: [
    "Limpieza facial con microdermoabrasión (Hydrafacial Elite)",
    "Toxina botulínica (Botox)",
    "Rellenos de ácido hialurónico",
    "Bioestimulantes (Sculptra, Profhilo)",
    "Microneedling (Dermapen)",
    "Peelings químicos",
    "Luz pulsada intensa",
    "Laser de CO2",
    "Laser Diodo (SOPRANO) para depilación",
    "Laser para tatuajes",
    "Laser para manchas de sol", 
    "Laser para enrojecimiento",
    "Laser para várices en las piernas",
    "Ultrasonido microfocalizado (Liftera)"
  ],
  medicinaQuirurgica: [
    "Cirugía de cáncer de piel (Mohs)",
    "Cirugía para lunares",
    "Lipomas",
    "Quistes",
    "Tatuajes",
    "Cicatrices"
  ]
};

export const testimonials = [
  { id: 1, name: "Maricela Mata", treatment: "Dermatología", rating: 5, date: "08/08/2025", text: "Para mí el Dr Adrian es el mejor dermatólogo. Muy acertado en sus decisiones en cuanto al tratamiento y siempre pensando a beneficio del paciente." },
  { id: 2, name: "Sam Garza", treatment: "Diagnóstico y Tratamiento", rating: 5, date: "04/08/2025", text: "La escucha es relevante y genera confianza en un paciente, para un buen diagnóstico y por ende un tratamiento exitoso." },
  { id: 3, name: "Maritza González", treatment: "Atención al paciente", rating: 5, date: "31/07/2025", text: "Muy buena atención hacia el paciente fue muy detallada y súper amable." },
  { id: 4, name: "Mariana Lozano", treatment: "Atención médica", rating: 5, date: "21/07/2025", text: "Muy buena atención del doctor, me transmitió mucha confianza." },
  { id: 5, name: "Leyda Alonso", treatment: "Diagnóstico y Servicio", rating: 5, date: "20/07/2025", text: "Excelente médico, excelente servicio. Muy claro en el diagnóstico. Muy satisfecha y sobre todo agradecida." },
  { id: 6, name: "José Luis Rodríguez G.", treatment: "Médico", rating: 5, date: "13/07/2025", text: "Muy explícito, amable y empático, nos pareció excelente médico." },
  { id: 7, name: "Adrian Aguilera", treatment: "Médico", rating: 5, date: "01/07/2025", text: "Excelente doctor! Muy recomendado. Cuenta con una dedicación, carisma y experiencia la cual me deja muy tranquilo de ser su paciente." },
  { id: 8, name: "Y.M", treatment: "Consulta médica", rating: 5, date: "30/06/2025", text: "Me sentí muy cómoda con la consulta del doctor es muy profesional." },
  { id: 9, name: "Ángel Galván", treatment: "Tratamientos dermatológicos", rating: 5, date: "30/06/2025", text: "Muy acertado en los tratamientos que ofrece, explicación detallada, muy atento y profesional. Ampliamente recomendado." },
  { id: 10, name: "Victor Canizales", treatment: "Consulta y Tratamiento", rating: 5, date: "29/06/2025", text: "Excelente explicación durante la consulta, su opinión me dejó tranquilo y el tratamiento también." },
  { id: 11, name: "MG", treatment: "Explicación de padecimiento", rating: 5, date: "27/06/2025", text: "Excelente explicación y muy detallada del padecimiento." },
  { id: 12, name: "Melissa Cortes", treatment: "Tratamiento para el acné", rating: 5, date: "17/06/2025", text: "La atención y el tratamiento que ha recibido mi hijo ha sido bueno ya que se ven los resultados en su acné." },
  { id: 13, name: "MDLR", treatment: "Diagnóstico", rating: 5, date: "11/06/2025", text: "Explicación detallada pero fácil de entender, diagnóstico oportuno." },
  { id: 14, name: "Ale", treatment: "Dermatología", rating: 5, date: "05/06/2025", text: "Excelente doctor, he ido con muchos dermatólogos y él resolvió y atendió todas mis dudas, y me dio un tratamiento apto para mi problema. Muy amable." },
  { id: 15, name: "LMGG", treatment: "Procedimiento médico", rating: 5, date: "03/06/2025", text: "Muy profesional en su explicación del caso y procedimiento a realizar explicando cada paso a seguir." },
  { id: 16, name: "Mariela García", treatment: "Atención y trato", rating: 5, date: "25/05/2025", text: "Todo muy bien, buena atención y buen trato. Recomendable." },
  { id: 17, name: "Adriana Valdez", treatment: "Médico y resultados", rating: 5, date: "25/05/2025", text: "Excelente Doctor te explica detalladamente, ves cambios rápidamente." },
  { id: 18, name: "RG", treatment: "Dermatología y acné", rating: 5, date: "15/05/2025", text: "Es el mejor dermatólogo que existe! Después de tener problemas de acné y manchas por años, y varios tratamientos con diferentes doctores había perdido la esperanza." },
  { id: 19, name: "Armine", treatment: "Tratamiento para el acné", rating: 5, date: "14/05/2025", text: "Muy buen doctor! me curó el problema de acné que tenía. Super buen trato." },
  { id: 20, name: "Lem", treatment: "Atención y explicación", rating: 5, date: "14/05/2025", text: "Me gustó la atención y la explicación que dio, sus instalaciones están muy agradables." },
  { id: 21, name: "Blanca Gzz", treatment: "Recomendaciones de productos", rating: 5, date: "07/05/2025", text: "Me gustó que te explica muy bien paso a paso de cada producto que te recomienda." },
  { id: 22, name: "MP", treatment: "Problema de piel", rating: 5, date: "05/05/2025", text: "Muy profesional! Me ayudó muchísimo un tema que tenía en mi piel lo recomiendo mucho." },
  { id: 23, name: "Arturo M.", treatment: "Servicio médico", rating: 5, date: "02/05/2025", text: "Excelente servicio y atención del doctor Barboza. Siempre atinado con su tratamiento y explicación de la situación." },
  { id: 24, name: "Gricelda Alanis", treatment: "Diagnóstico y tratamiento", rating: 5, date: "29/04/2025", text: "Excelente atención excelente, Dr. Te examina, y te explica el problema que traes, y sobre todo te da el tratamiento adecuado a tu problema." },
  { id: 25, name: "DIRC", treatment: "Consulta", rating: 5, date: "28/04/2025", text: "Excelente atención del Dr Adrian, muy detallada toda la consulta!" },
  { id: 26, name: "Daniela Juárez", treatment: "Explicación médica", rating: 5, date: "24/04/2025", text: "Me dio mucha tranquilidad su explicación y sinceridad, muy respetuoso y amable." },
  { id: 27, name: "Cesar", treatment: "Tratamientos médicos", rating: 5, date: "23/04/2025", text: "Un excelente doctor, muy acertado con sus tratamientos, y de un excelente trato." },
  { id: 28, name: "GBDV", treatment: "Atención y tratamiento", rating: 5, date: "22/04/2025", text: "Muy buena atención y explicación del tratamiento." },
  { id: 29, name: "PME", treatment: "Consulta", rating: 5, date: "20/04/2025", text: "Excelente atención!! explicación muy clara de todas las dudas en consulta." },
  { id: 30, name: "Lupina de la Rosa", treatment: "Atención y trato", rating: 5, date: "08/04/2025", text: "Muy buena atención, trato amable y es muy bueno que vuelvan las consultas en sábado." },
  { id: 31, name: "RH Rogelio Herrera Peña", treatment: "Servicio y trato", rating: 5, date: "31/03/2025", text: "Excelente servicio y trato personalizado y 100% recomendable el Dr. Adrian Cuéllar." },
  { id: 32, name: "RS RSG", treatment: "Atención y consultas", rating: 5, date: "27/03/2025", text: "Excelente atención, puntualidad, despeja tus dudas, súper recomendable." },
  { id: 33, name: "CD C.C. de C.", treatment: "Consulta médica", rating: 5, date: "26/03/2025", text: "Fui remitida de otro médico, el Dr. Cuéllar me recibió, teniendo ya toda la información de mi caso, siendo claro en todo." },
  { id: 34, name: "BM Beba Mier", treatment: "Dermatología y skincare", rating: 5, date: "21/03/2025", text: "Excelente dermatólogo. Cada día me veo más joven. El skincare que me recomendó ha mostrado un cambio muy notorio; mi piel está más hidratada." },
  { id: 35, name: "AA Adriana A.", treatment: "Tratamiento médico", rating: 5, date: "20/03/2025", text: "Extraordinario servicio y atención. Tratamiento sin dolor y eficaz." },
  { id: 36, name: "MC M.C.", treatment: "Acné", rating: 5, date: "18/03/2025", text: "Excelente doctor, atención y seguimiento puntual, me ayudó muchísimo con mi acné." },
  { id: 37, name: "J Jessica", treatment: "Dermatología", rating: 5, date: "14/03/2025", text: "Excelente dermatólogo, explicación clara y amabilidad." },
  { id: 38, name: "MN Miguel Ángel Hernández", treatment: "Explicación de consulta", rating: 5, date: "13/03/2025", text: "Muy detallada cada explicación y cada duda resuelta." },
  { id: 39, name: "MM MMQ", treatment: "Consulta y tratamiento", rating: 5, date: "11/03/2025", text: "Fue muy atento y profesional el Dr., explicando cada detalle de la consulta y tratamiento." },
  { id: 40, name: "AC A.C.", treatment: "Trato médico", rating: 5, date: "11/03/2025", text: "Excelente trato del doctor, muy empático y amable." },
  { id: 41, name: "FC F.C.", treatment: "Servicio médico", rating: 5, date: "10/03/2025", text: "Excelente servicio, el doctor explica todo súper bien." },
  { id: 42, name: "RB RB", treatment: "Médico y tranquilidad", rating: 5, date: "04/03/2025", text: "El Dr. Adrián es un extraordinario médico, que ha resuelto nuestros problemas brindando tranquilidad en el proceso. Muy recomendable." },
  { id: 43, name: "DA Daniela", treatment: "Servicio y atención", rating: 5, date: "27/02/2025", text: "Todo súper bien, excelente servicio del Dr. Adrián, muy atento y dedicado en los problemas que tenía." },
  { id: 44, name: "MA Mariel Alejandra Sánchez Leal", treatment: "Médico y cicatriz queloide", rating: 5, date: "24/02/2025", text: "Es un excelente doctor, lo recomiendo mucho. Gracias a él ya no tengo cicatriz queloide." },
  { id: 45, name: "EM Edith Mata", treatment: "Atención y confianza", rating: 5, date: "23/02/2025", text: "Desde que llegas la atención es amable con las chicas de recepción y el doctor muy amable y muy atento. Inmediatamente me hizo sentir en total confianza." },
  { id: 46, name: "LR Laura Rendón", treatment: "Trato y productos", rating: 5, date: "16/02/2025", text: "Buen trato, accesible, me inspiró confianza. Sus productos de calidad y precio razonable." },
  { id: 47, name: "VD VDLR", treatment: "Médico", rating: 5, date: "13/02/2025", text: "Excelente médico, muy recomendado, es muy profesional." },
  { id: 48, name: "JP JPC", treatment: "Consulta", rating: 5, date: "11/02/2025", text: "La atención a la consulta fue muy buena y asertiva." },
  { id: 49, name: "ML María Leza", treatment: "Médico y humano", rating: 5, date: "03/02/2025", text: "Excelente médico y ser humano. Lo recomiendo 100%." },
  { id: 50, name: "AP Angélica P.", treatment: "Trato y diagnóstico", rating: 5, date: "26/01/2025", text: "En resumen, el Dr. Cuéllar-Barboza me brindó un excelente trato y atención profesional. Su diagnóstico fue preciso." }
];

export const beforeAfterGallery = [
  {
    id: 1,
    treatment: "Relleno de labios (HA)",
    image: "https://customer-assets.emergentagent.com/job_derma-centro/artifacts/jzsmwuau_REELNO%20DE%20LABIOS.JPG"
  },
  {
    id: 2,
    treatment: "Sculptra (Bioestimulante)",
    image: "https://customer-assets.emergentagent.com/job_derma-centro/artifacts/0gblt2qd_SCULPTRA.png"
  },
  {
    id: 3,
    treatment: "Botox",
    image: "https://customer-assets.emergentagent.com/job_derma-centro/artifacts/edd9wqdr_BOTOX%201.png"
  },
  {
    id: 4,
    treatment: "Botox",
    image: "https://customer-assets.emergentagent.com/job_derma-centro/artifacts/ej2jlrnh_BOTOX%202.png"
  },
  {
    id: 5,
    treatment: "Alopecia Androgenetica",
    image: "https://customer-assets.emergentagent.com/job_derma-centro/artifacts/f8sk76qv_ALOPECIA%20ANDROGENETICA.JPG"
  },
  {
    id: 6,
    treatment: "Alopecia Patron Femenino",
    image: "https://customer-assets.emergentagent.com/job_derma-centro/artifacts/j26uvz8h_ALOPECIA%20PATRON%20FEMENINO.JPG"
  },
  {
    id: 7,
    treatment: "Cancer de Piel",
    image: "https://customer-assets.emergentagent.com/job_derma-centro/artifacts/nthluej1_CANCER%20DE%20PIEL.png"
  }
];

export const skincareTips = [
  {
    id: 1,
    title: "Protección Solar Diaria",
    category: "Prevención",
    readTime: "3 min lectura",
    excerpt: "Aprende por qué el SPF 30+ debe ser el mejor amigo de tu piel, incluso en días nublados.",
    content: "La protección solar es el paso más importante en cualquier rutina de cuidado de la piel. Los rayos UV causan envejecimiento prematuro, manchas oscuras y aumentan el riesgo de cáncer de piel. Aplica SPF 30+ de amplio espectro diariamente, reaplica cada 2 horas y no olvides las áreas que se pasan por alto como orejas y cuello.",
    image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=300&fit=crop",
    tips: [
      "Usa SPF 30 o superior de amplio espectro",
      "Aplica 15-20 minutos antes de la exposición al sol",
      "Reaplica cada 2 horas o después de nadar",
      "No olvides labios, orejas y cuello"
    ]
  },
  {
    id: 2,
    title: "Conociendo tu Tipo de Piel",
    category: "Básicos",
    readTime: "4 min lectura",
    excerpt: "Descubre tu tipo de piel y aprende cómo elegir los productos correctos para una salud cutánea óptima.",
    content: "Conocer tu tipo de piel es crucial para seleccionar productos efectivos. Los tipos principales son normal, seca, grasa, mixta y sensible. Cada uno requiere enfoques diferentes para limpieza, hidratación y tratamiento.",
    image: "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=400&h=300&fit=crop",
    tips: [
      "Observa tu piel en la mañana",
      "Considera cómo se siente después de la limpieza",
      "Nota cualquier área problemática o sensibilidad",
      "Consulta a un dermatólogo para evaluación profesional"
    ]
  },
  {
    id: 3,
    title: "El Poder de los Retinoides",
    category: "Anti-envejecimiento",
    readTime: "5 min lectura",
    excerpt: "Descubre los beneficios de los retinoides para una piel más suave y joven con pautas de uso adecuadas.",
    content: "Los retinoides son ingredientes estándar de oro para el tratamiento anti-envejecimiento y del acné. Promueven la renovación celular, reducen las líneas finas y mejoran la textura de la piel. Comienza lentamente para desarrollar tolerancia y siempre usa protector solar cuando uses productos con retinoides.",
    image: "https://images.unsplash.com/photo-1596755389378-c31d21fd1273?w=400&h=300&fit=crop",
    tips: [
      "Comienza con baja concentración 2-3 veces por semana",
      "Aplica sobre piel limpia y seca antes del humectante",
      "Siempre usa protector solar durante el tratamiento con retinoides",
      "Espera sequedad inicial - esto es normal"
    ]
  }
];

export const contactInfo = {
  phone: "+52 81 8022 9385",
  whatsapp: "+52 81 8022 9385",
  whatsappMessage: "Me gustaría agendar cita con el Dr. Adrián Cuéllar ¿Me puedes compartir información?",
  email: "dradriancuellar@gmail.com",
  googleMapsUrl: "https://share.google/smtahaiN643f92uGV",
  googleMapsShareUrl: "https://share.google/smtahaiN643f92uGV",
  address: {
    street: "Calzada del Valle 400, Moll del Valle, Torre 3, Piso N6, Local 6B",
    reference: "(Esquina de la calle Rio Rosas con avenida Calzada del Valle)",
    neighborhood: "Colonia Del Valle",
    city: "San Pedro Garza García",
    state: "Nuevo León",
    zip: "66220"
  },
  hours: {
    lunes: "9:30 AM - 8:30 PM",
    martes: "9:30 AM - 8:30 PM",
    miércoles: "9:30 AM - 8:30 PM",
    jueves: "9:30 AM - 8:30 PM",
    viernes: "9:30 AM - 8:30 PM",
    sábado: "9:30 AM - 1:30 PM",
    domingo: "Cerrado"
  }
};